import { Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import { useAccountDetailsContext } from './AccountDetailsContext';

interface UsePricingPropertiesParams {
  monthlyPaymentCapText: string;
  adjustMonthlyPaymentCap: boolean;
}

export function usePricingProperties({
  monthlyPaymentCapText,
  adjustMonthlyPaymentCap,
}: UsePricingPropertiesParams) {
  const { account, isLightReachAdmin, openModal } = useAccountDetailsContext();

  if (!isLightReachAdmin) return null;

  return {
    heading: 'Pricing Details',
    showInternalOnly: true,
    values: [
      {
        label: 'Price Mappings',
        value: account?.priceSheetMappingId ? (
          <Link
            to={`${location.origin}/settings/organizations/${account?.licensedOrganizationId}/pricing/${account.programType}/mappings?id=${account?.priceSheetMappingId}`}
          >
            Account Pricing
          </Link>
        ) : (
          'N/A'
        ),
      },
      {
        label: 'Monthly Payment Cap',
        value: (
          <Box gap="xs">
            <Box>{monthlyPaymentCapText}</Box>

            {adjustMonthlyPaymentCap && monthlyPaymentCapText && (
              <Box
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => openModal('adjustPaymentCap')}
              >
                Adjust Monthly Payment Cap
              </Box>
            )}
          </Box>
        ),
      },
    ],
  };
}
